import { render, staticRenderFns } from "./ConvertibleNotes.vue?vue&type=template&id=dd12b106&scoped=true&"
import script from "./ConvertibleNotes.vue?vue&type=script&lang=ts&"
export * from "./ConvertibleNotes.vue?vue&type=script&lang=ts&"
import style0 from "./ConvertibleNotes.vue?vue&type=style&index=0&id=dd12b106&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd12b106",
  null
  
)

export default component.exports